import { useCallback, useState } from 'react';
import { clientService } from '../services/clients/ClientService';
import {
  mapMeuTimHealthCheckResponse,
  mapMeuTimVerifyOnDemandError,
  MeuTimVerifyOnDemandResult,
  MeuTimVerifyUiStatus,
} from '../utils/meuTimVerifyOnDemand';

export interface UseMeuTimVerifyOnDemand {
  status: MeuTimVerifyUiStatus;
  result: MeuTimVerifyOnDemandResult | null;
  verifying: boolean;
  /** Dispara o verify on-demand agora (fatia 0). Nunca lança — resolve sempre com um resultado real. */
  verifyNow: (clientId: string) => Promise<MeuTimVerifyOnDemandResult>;
  reset: () => void;
}

/**
 * Helper único de verify Meu TIM on-demand (fatia 0 GCM), usado pelas 3 superfícies
 * (novo contrato, detalhes das linhas, suspensões). Resultado real do worker/portal —
 * nunca marca sucesso só por ter disparado a chamada.
 */
export function useMeuTimVerifyOnDemand(): UseMeuTimVerifyOnDemand {
  const [verifying, setVerifying] = useState(false);
  const [result, setResult] = useState<MeuTimVerifyOnDemandResult | null>(null);

  const verifyNow = useCallback(async (clientId: string): Promise<MeuTimVerifyOnDemandResult> => {
    setVerifying(true);
    try {
      const response = await clientService.verifyMeuTimHealthNow(clientId);
      const mapped = mapMeuTimHealthCheckResponse(response);
      setResult(mapped);
      return mapped;
    } catch (err) {
      const mapped = mapMeuTimVerifyOnDemandError(err);
      setResult(mapped);
      return mapped;
    } finally {
      setVerifying(false);
    }
  }, []);

  const reset = useCallback(() => setResult(null), []);

  return {
    status: verifying ? 'loading' : result?.status ?? 'idle',
    result,
    verifying,
    verifyNow,
    reset,
  };
}
